import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "checkCheck" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "icon" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M17.4 6.825L7.5 16.725L3 12.225",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M20.9999 10.425L14.2499 17.175L12.8999 15.825",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }